import { Box } from '@atgfr8/atg-ui-tailwind';

interface LinkProps {
  title: string;
  url: string;
  target?: string;
  lineHeight?: string;
  fontWeight?: string;
  fontSize?: string;
  className?: string;
  download?: string;
}

const LinkComponent = (props: LinkProps) => {
  const linkContent = (
    <Box class="flex">
      <a
        href={props.url}
        target={props.target}
        class={props.className}
        download={props.download}
        style={{
          'line-height':
            props.lineHeight !== undefined ? props.lineHeight : '24px',
          'letter-spacing': '0.15px',
          'font-size': props.fontSize !== undefined ? props.fontSize : '16px',
          'font-style': 'normal',
          'font-weight':
            props.fontWeight !== undefined ? props.fontWeight : '400',
        }}
      >
        {props.title}
      </a>
    </Box>
  );

  return <Box class="flex flex-col items-center">{linkContent}</Box>;
};

export default LinkComponent;
